import React, { useState } from "react";
import { ListCuadernoTable } from "./ListCuadernoTable";
import { Routes, Route } from "react-router-dom";
import { ErrorPage } from "../../../error/errorPage";
import { CuadernoHistorial } from "./cuaderno_historial";
import { Title1 } from "../../../../components/text/titles";

export const Cuaderno = () => {
  const [cuadernosChanged, setCuadernosChanged] = useState(false);

  const blocks = [
    { abierto: true,  revisado: null,  title: "CUADERNOS ABIERTOS" },
    { abierto: false, revisado: false, title: "CUADERNOS CERRADOS" },
    { abierto: null,  revisado: true,  title: "CUADERNOS REVISADOS" },
  ];

  return (
    <Routes>
      <Route
        index
        element={
          <div className="flex flex-col gap-4">
            {blocks.map((b, idx) => (
              <div
                key={idx}
                className="bg-gray-50 dark:bg-gray-800/50 rounded-sm p-2"
              >
                <Title1 text={b.title} />
                <ListCuadernoTable
                  abierto={b.abierto}
                  revisado={b.revisado}
                  // abiertos se recargan cuando cambie el flag
                  {...(b.abierto === true
                    ? { changed: cuadernosChanged }
                    : {})}
                  // cerrados avisan al principal cuando reabres
                  {...(b.abierto === false && b.revisado === false
                    ? { onReopen: () => setCuadernosChanged((x) => !x) }
                    : {})}
                />
              </div>
            ))}
          </div>
        }
      />
      <Route path={`/historial/:cuaderno_id/*`} element={<CuadernoHistorial />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
